import React, { Component } from "react";
import { PipePDFReportStyles } from "./pdfreport.stylesheet";
import { Document, Page, PDFViewer, Text, View, Image } from "@react-pdf/renderer";
import store from "../../store";
import pipeSelectors from "../../lib/pipe-selectors";
import {
    METRIC,
    IMPERIAL,
    PIPE_TYPE_SOIL_TIGHT_PERFORATED_ID,
} from "../../lib/types";
import { connect } from "react-redux";
import MultiBedService from "../../lib/services/multibed-service";

const logoImg = require("../../media/cultec-stormgenie-logo.png");
const css = PipePDFReportStyles;

class MbPipesPdfReport extends Component{
    multibed = [1, 2];

    state = {
        showPDF: false,
        processedBeds: [],
    };

    async componentDidMount() {
        MultiBedService.getMultibedDataForPDF(this.props)
            .then(( dt ) => {
                this.setState({
                    processedBeds: [...dt],
                    showPDF: true,
                });
            });
    }

    render() {
        const {
            lbl,
            unit,
            lang,
            user,
            content,
            projectInfo,
            pipeFitting,
            projectDefault,
        } = this.props;

        const project = projectDefault || projectInfo;

        const fullName = user ? `${user.givenName} ${user.surname}` : "N/A";

        const formatNum = ( val ) => {
            return val && typeof val === "number"
                ? Number.isInteger(val) ? Math.floor(val) : val.toFixed(2)
                : val;
        };

        const renderPorosityPercent = ( bed ) => {
            if (bed.pipeGlobals.pipeFitting._id !== PIPE_TYPE_SOIL_TIGHT_PERFORATED_ID) {
                return <View/>;
            } else {
                return ( <View style={css.rowView}>
                    <View style={css.innerLColView}>
                        <Text style={css.tableTextBold}>
                            {content[lang].stonePorosityPdf}
                        </Text>
                    </View>
                    <View style={css.innerRColView}>
                        <Text style={css.tableText}>
                            {formatNum(bed.pipeGlobals.pipeStonePorosity)}%
                        </Text>
                    </View>
                </View> );
            }
        };

        const convertUnits = ( value, unitType ) => {
            let unitValue = 0;
            switch (unit) {
                case METRIC:
                    switch (unitType) {
                        case "ft": // Feets to meters
                            unitValue = parseFloat(Math.round(( value * 0.3048 ) * 100) / 100).toFixed(2);
                            break;
                        case "in": // Inches to milimeters
                            unitValue = Math.round(Math.round(( value * 25.4 ) * 100) / 100);
                            break;
                        case "sf": //
                            unitValue = parseFloat(Math.round(( value / 10.764 ) * 100) / 100).toFixed(2);
                            break;
                        case "cf": // Cubic feets to cubic meters
                            unitValue = parseFloat(Math.round(( value / 35.315 ) * 100) / 100).toFixed(2);
                            break;
                        case "cy": // Cubic yards to cubic meters
                            unitValue = parseFloat(Math.round(( value / 1.308 ) * 100) / 100).toFixed(2);
                            break;
                        default:
                            unitValue = Math.round(value * 100) / 100;
                            break;
                    }
                    break;
                case IMPERIAL:
                    unitValue = formatNum(value);
                    break;
                default:
                    break;
            }
            return unitValue;
        };

        return (
            <React.Fragment>
                {this.state.showPDF ? (
                    <PDFViewer style={css.viewer}>
                        <Document
                            style={css.document}
                            onRender={this.handleOnRender}
                            title={content[lang].adsPdfReport}
                            author={content[lang].adsDesignTool}
                            creator={content[lang].adsDesignTool}
                            producer={content[lang].adsDesignTool}
                            subject={content[lang].adsCalculationsReport}
                            keywords={"ADS Design Tool, Advance Solutions, Report, PDF, Calculations"}
                        >
                            {( this.state.processedBeds && this.state.processedBeds.length > 0 )
                                ? this.state.processedBeds
                                    .map(( bed ) => {
                                        // const tempState = bed.state;
                                        const tempState = store.getState();
                                        return (
                                            <Page key={bed.id} wrap={false}>
                                                {/* Header image */}
                                                <View style={css.headerView}>
                                                    <Image src={logoImg} style={css.logoImgStyle}/>
                                                </View>

                                                <View style={css.rowView}>
                                                    <View style={css.colView}>
                                                        {/* User inputs column */}
                                                        <Text style={css.titleText}>{content[lang].userInputs}</Text>

                                                        <View style={css.rowView}>
                                                            <View style={css.innerLColView}>
                                                                <Text style={css.tableTextBold}>{content[lang].projectName} </Text>
                                                            </View>
                                                            <View style={css.innerRColView}>
                                                                <Text style={css.tableText}>{project.projectName}</Text>
                                                            </View>
                                                        </View>

                                                        <View style={css.rowView}>
                                                            <View style={css.innerLColView}>
                                                                <Text style={css.tableTextBold}>{content[lang].bedName} </Text>
                                                            </View>
                                                            <View style={css.innerRColView}>
                                                                <Text style={css.tableText}>{bed.name}</Text>
                                                            </View>
                                                        </View>

                                                        <View style={css.rowView}>
                                                            <View style={css.innerLColView}>
                                                                <Text style={css.tableTextBold}>{content[lang].state}: </Text>
                                                            </View>
                                                            <View style={css.innerRColView}>
                                                                <Text style={css.tableText}>{project.state}</Text>
                                                            </View>
                                                        </View>

                                                        <View style={css.rowView}>
                                                            <View style={css.innerLColView}>
                                                                <Text style={css.tableTextBold}>{content[lang].city}: </Text>
                                                            </View>
                                                            <View style={css.innerRColView}>
                                                                <Text style={css.tableText}>{project.city}</Text>
                                                            </View>
                                                        </View>

                                                        <View style={css.rowView}>
                                                            <View style={css.innerLColView}>
                                                                <Text style={css.tableTextBold}>{content[lang].engineer}: </Text>
                                                            </View>
                                                            <View style={css.innerRColView}>
                                                                <Text style={css.tableText}>{fullName}</Text>
                                                            </View>
                                                        </View>

                                                        <View style={css.rowView}>
                                                            <View style={css.innerLColView}>
                                                                <Text style={css.tableTextBold}>{content[lang].measurementType} </Text>
                                                            </View>
                                                            <View style={css.innerRColView}>
                                                                <Text
                                                                    style={css.tableText}>{unit.charAt(0).toUpperCase() + unit.slice(1)}</Text>
                                                            </View>
                                                        </View>

                                                        <View style={css.rowView}>
                                                            <View style={css.innerLColView}>
                                                                <Text style={css.tableTextBold}>{content[lang].product} </Text>
                                                            </View>
                                                            <View style={css.innerRColView}>
                                                                <Text style={css.tableText}>{bed.pipeGlobals.pipeType._name}</Text>
                                                            </View>
                                                        </View>

                                                        <View style={css.rowView}>
                                                            <View style={css.innerLColView}>
                                                                <Text style={css.tableTextBold}>{content[lang].nominalDiameter} </Text>
                                                            </View>
                                                            <View style={css.innerRColView}>
                                                                <Text
                                                                    style={css.tableText}>{bed.pipeGlobals.pipeNominalDiameter._pipeND._inches}</Text>
                                                            </View>
                                                        </View>

                                                        <View style={css.rowView}>
                                                            <View style={css.innerLColView}>
                                                                <Text style={css.tableTextBold}>{content[lang].requiredVolumePdf} </Text>
                                                            </View>
                                                            <View style={css.innerRColView}>
                                                                <Text style={css.tableText}>
                                                                    {convertUnits(bed.pipeGlobals.pipeRequiredVolume, "cf")} {lbl[unit].cubicFeet[lang]}.
                                                                </Text>
                                                            </View>
                                                        </View>

                                                        <Text> &nbsp; </Text>

                                                        <View style={css.rowView}>
                                                            <View style={css.innerLColView}>
                                                                <Text style={css.tableTextBold}>{content[lang].availableLengthPdf} </Text>
                                                            </View>
                                                            <View style={css.innerRColView}>
                                                                <Text
                                                                    style={css.tableText}>{convertUnits(bed.pipeGlobals.pipeAvailableLength, "ft")} {lbl[unit].ft[lang]}.</Text>
                                                            </View>
                                                        </View>

                                                        <View style={css.rowView}>
                                                            <View style={css.innerLColView}>
                                                                <Text style={css.tableTextBold}>{content[lang].availableWidthPdf} </Text>
                                                            </View>
                                                            <View style={css.innerRColView}>
                                                                <Text
                                                                    style={css.tableText}>{convertUnits(bed.pipeGlobals.pipeAvailableWidth, "ft")} {lbl[unit].ft[lang]}.</Text>
                                                            </View>
                                                        </View>

                                                        <View style={css.rowView}>
                                                            <View style={css.innerLColView}>
                                                                <Text style={css.tableTextBold}>
                                                                    {pipeFitting._id !== PIPE_TYPE_SOIL_TIGHT_PERFORATED_ID ? content[lang].pipeFillAbovePdf : content[lang].stoneAbovePdf}
                                                                </Text>
                                                            </View>
                                                            <View style={css.innerRColView}>
                                                                <Text
                                                                    style={css.tableText}>{convertUnits(bed.pipeGlobals.pipeStoneAbove, "in")} {lbl[unit].in[lang]}.</Text>
                                                            </View>
                                                        </View>

                                                        <View style={css.rowView}>
                                                            <View style={css.innerLColView}>
                                                                <Text style={css.tableTextBold}>
                                                                    {pipeFitting._id !== PIPE_TYPE_SOIL_TIGHT_PERFORATED_ID ? content[lang].pipeBeddingBelowPdf : content[lang].stoneBelowPdf}
                                                                </Text>
                                                            </View>
                                                            <View style={css.innerRColView}>
                                                                <Text
                                                                    style={css.tableText}>{convertUnits(bed.pipeGlobals.pipeStoneBelow, "in")} {lbl[unit].in[lang]}.</Text>
                                                            </View>
                                                        </View>
                                                        {renderPorosityPercent(bed)}
                                                    </View>

                                                    <View style={css.colView}>
                                                        {/* Results column */}
                                                        <Text style={css.titleText}>{content[lang].results}</Text>

                                                        <View style={css.rowView}>
                                                            <View style={css.innerLColView}>
                                                                <Text style={css.tableTextBold}>{content[lang].installedStorageVolume}
                                                                </Text>
                                                            </View>
                                                            <View style={css.innerRColView}>
                                                                <Text style={css.tableText}>
                                                                    {convertUnits(bed.pipeGlobals.volume, "cf")} {lbl[unit].cubicFeet[lang]}.
                                                                </Text>
                                                            </View>
                                                        </View>

                                                        <View style={css.rowView}>
                                                            <View style={css.innerLColView}>
                                                                <Text style={css.tableTextBold}>{content[lang].systemLengthPdf} </Text>
                                                            </View>
                                                            <View style={css.innerRColView}>
                                                                <Text style={css.tableText}>
                                                                    {convertUnits(bed.pipeBed.stoneBedDimensions.height.ft, "ft") || 0} {lbl[unit].ft[lang]}.
                                                                </Text>
                                                            </View>
                                                        </View>

                                                        <View style={css.rowView}>
                                                            <View style={css.innerLColView}>
                                                                <Text style={css.tableTextBold}>{content[lang].systemWidthPdf} </Text>
                                                            </View>
                                                            <View style={css.innerRColView}>
                                                                <Text style={css.tableText}>
                                                                    {convertUnits(bed.pipeBed.stoneBedDimensions.width.ft, "ft") || 0} {lbl[unit].ft[lang]}.
                                                                </Text>
                                                            </View>
                                                        </View>

                                                        <View style={css.rowView}>
                                                            <View style={css.innerLColView}>
                                                                <Text style={css.tableTextBold}>{content[lang].numberOfRows}: </Text>
                                                            </View>
                                                            <View style={css.innerRColView}>
                                                                <Text style={css.tableText}>
                                                                    {bed.pipeBed.numberOfPipeRows}
                                                                </Text>
                                                            </View>
                                                        </View>

                                                        <View style={css.rowView}>
                                                            <View style={css.innerLColView}>
                                                                <Text
                                                                    style={css.tableTextBold}>{content[lang].approxBedSizeRequired} </Text>
                                                            </View>
                                                            <View style={css.innerRColView}>
                                                                <Text style={css.tableText}>
                                                                    {convertUnits(bed.pipeBed.area, "sf") || 0} {lbl[unit].squareFeet[lang]}.
                                                                </Text>
                                                            </View>
                                                        </View>

                                                        <Text> &nbsp; </Text>

                                                        <Text style={css.titleText}>{content[lang].systemComponents}</Text>

                                                        <View style={css.rowView}>
                                                            <View style={css.innerLColView}>
                                                                <Text style={css.tableTextBold}>
                                                                    {pipeFitting._id !== PIPE_TYPE_SOIL_TIGHT_PERFORATED_ID ? content[lang].amountOfFillRequired : content[lang].amountOfStoneRequired}
                                                                </Text>
                                                            </View>
                                                            <View style={css.innerRColView}>
                                                                <Text style={css.tableText}>
                                                                    {convertUnits(( pipeSelectors.pipeStoneBedAmount(tempState) / Math.pow(3, 3) ), "cy") || 0} {lbl[unit].cubicYard[lang]}
                                                                </Text>
                                                            </View>
                                                        </View>

                                                        <View style={css.rowView}>
                                                            <View style={css.innerLColView}>
                                                                <Text style={css.tableTextBold}>
                                                                    {content[lang].volumeOfExcavationPipes} </Text>
                                                            </View>
                                                            <View style={css.innerRColView}>
                                                                <Text style={css.tableText}>
                                                                    {convertUnits(
                                                                        ( pipeSelectors.pipeTotalExcavation(tempState) / Math.pow(3, 3) ), "cy",
                                                                    ) || 0} {lbl[unit].cubicYard[lang]}
                                                                </Text>
                                                            </View>
                                                        </View>

                                                    </View>
                                                </View>
                                            </Page> );
                                    })
                                : null
                            }
                        </Document>
                    </PDFViewer>
                ) : ( <p>...</p> )}
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.authentication.user,
        resourcesTokens: state.authentication.resourcesTokens,
    };
};

export default connect(
    mapStateToProps,
    {},
)(MbPipesPdfReport);



// WEBPACK FOOTER //
// ./src/components/PipesPDF/mb_pipePdfReport.component.js